export class AnoAgricola {
    Id: number;
    Descricao:string = "";
}
